import { apiFetch } from './api';

// Third Party COA API
export function listThirdPartyCOAs({ search = '', page = 1, limit = 20, status } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status) params.set('status', status);
  params.set('page', String(page));
  params.set('limit', String(limit));
  const q = params.toString() ? `?${params.toString()}` : '';
  return apiFetch(`/api/admin/third-party-coas${q}`);
}

export function createThirdPartyCOA(payload) {
  return apiFetch('/api/admin/third-party-coas', { method: 'POST', body: payload });
}

export function getThirdPartyCOA(id) {
  return apiFetch(`/api/admin/third-party-coas/${id}`);
}

export function updateThirdPartyCOA(id, payload) {
  return apiFetch(`/api/admin/third-party-coas/${id}`, { method: 'PATCH', body: payload });
}

export function deleteThirdPartyCOA(id) {
  return apiFetch(`/api/admin/third-party-coas/${id}`, { method: 'DELETE' });
}
